import { useQuery } from '@apollo/client/react';
import { Formik } from 'formik';
import { useAutotagFeatureAvailability } from 'app/domains/metadata/hooks/useAutotagFeatureAvailability';
import { AclAction } from 'shared/domains/apollo/generated/types';
import { ErrorDialog } from './ErrorDialog';
import { FileSystemManagerDocument } from './FileSystemManager.gql';
import { LoadingDialog } from './LoadingDialog';
import { FileSystemManagerSchema } from './schema';
import { calculateACLChanges } from '../../AccessManagement/calculateACLChanges';
import FolderPickerDialog from '../../FolderPickerDialog';
import FileSystemDialog from '../FileSystemDialog';
export function FileSystemManager(props) {
    var _a, _b;
    const { defaultParentId, defaultName, onSubmit, onClose, entryType, error, onDiscard } = props;
    const autoTagFeature = useAutotagFeatureAvailability();
    const { data, loading, error: queryError, refetch, } = useQuery(FileSystemManagerDocument, {
        variables: {
            parentId: defaultParentId || '',
            withParentId: Boolean(defaultParentId),
        },
    });
    const initialUserAcls = ((_a = data === null || data === void 0 ? void 0 : data.parentFolder) === null || _a === void 0 ? void 0 : _a.userAcls.filter((acl) => !acl.actions.includes(AclAction.Traverse))) || [];
    const initialTeamAcls = ((_b = data === null || data === void 0 ? void 0 : data.parentFolder) === null || _b === void 0 ? void 0 : _b.teamAcls.filter((acl) => !acl.actions.includes(AclAction.Traverse))) || [];
    const isDevelopmentEnvironment = process.env.APP_ENV !== 'production';
    const autoTag = isDevelopmentEnvironment ? false : autoTagFeature.data;
    const initialValues = {
        name: defaultName || '',
        parentId: defaultParentId,
        userAcls: initialUserAcls,
        teamAcls: initialTeamAcls,
        projects: [],
        autoTag,
    };
    const handleOnSubmit = (values, helpers) => {
        const userAcls = calculateACLChanges(initialValues.userAcls, values.userAcls);
        const teamAcls = calculateACLChanges(initialValues.teamAcls, values.teamAcls);
        return onSubmit(Object.assign(Object.assign({}, values), { userAcls: userAcls.toCreate, teamAcls: teamAcls.toCreate }), helpers);
    };
    if (loading) {
        return <LoadingDialog />;
    }
    if (error) {
        return <ErrorDialog onClose={onClose}/>;
    }
    if (queryError) {
        return <ErrorDialog onClose={onClose} onRetry={refetch}/>;
    }
    return (<Formik initialValues={initialValues} validationSchema={FileSystemManagerSchema} onSubmit={handleOnSubmit} validateOnMount>
      {({ values, setFieldValue }) => {
            var _a;
            if (values.parentId === 'otherOptions') {
                return (<FolderPickerDialog defaultParentId={defaultParentId} entryType={entryType} actionType="create" onSubmit={(folder) => { var _a; return setFieldValue('parentId', (_a = folder === null || folder === void 0 ? void 0 : folder.id) !== null && _a !== void 0 ? _a : null); }} onClose={() => setFieldValue('parentId', null)}/>);
            }
            return (<FileSystemDialog onDiscard={onDiscard} entryType={entryType} onClose={onClose} selectedId={(_a = values.parentId) !== null && _a !== void 0 ? _a : undefined}/>);
        }}
    </Formik>);
}
